import { render, staticRenderFns } from "./commonSelection.vue?vue&type=template&id=20dfe644&scoped=true"
import script from "./commonSelection.vue?vue&type=script&lang=js"
export * from "./commonSelection.vue?vue&type=script&lang=js"
import style0 from "./commonSelection.vue?vue&type=style&index=0&id=20dfe644&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20dfe644",
  null
  
)

export default component.exports